import React, { Fragment } from 'react';
import { Button } from 'react-bootstrap';

import Modal from 'components/common-sfims/modal/Common';
import { getText } from 'function/language';
import { useConfirmModalState } from 'global/confirmModalState';
import valueFrom from 'utils/valueFrom';

/**
 * 메시지 모달
 */
const Message = () => {
  /* recoil */
  const {
    confirmModal: {
      isOpen,
      title,
      message,
      isCancelBtn,
      isConfirmBtn,
      btnNm,
      onConfirm
    },
    resetConfirmModal
  } = useConfirmModalState();

  /* event */
  // 확인 클릭 시
  const onConfirmClick = () => {
    resetConfirmModal();
    onConfirm();
  };

  /* view */
  return (
    <Modal
      show={isOpen}
      className={{ body: 'px-card pb-card fs--0 text-center' }}
      contentClassName="border"
      onHide={resetConfirmModal}
    >
      <Fragment key="header">
        {valueFrom(valueFrom(getText(title), title), getText('notice'))}
      </Fragment>
      <Fragment key="body">
        <p className="mb-0" style={{ whiteSpace: 'pre-line' }}>
          {valueFrom(getText(message), message)}
        </p>
      </Fragment>
      <Fragment key="footer">
        {isCancelBtn && (
          <Button size="sm" variant="secondary" onClick={resetConfirmModal}>
            <span>{getText('cancel')}</span>
          </Button>
        )}
        {isConfirmBtn && (
          <Button size="sm" variant="primary" onClick={onConfirmClick}>
            <span>
              {valueFrom(
                valueFrom(getText(btnNm), btnNm),
                getText(isCancelBtn ? 'ok' : 'close')
              )}
            </span>
          </Button>
        )}
      </Fragment>
    </Modal>
  );
};

export default Message;
